import { render, staticRenderFns } from "./CoverLoader.vue?vue&type=template&id=3a8ce498&scoped=true&"
import script from "./CoverLoader.vue?vue&type=script&lang=js&"
export * from "./CoverLoader.vue?vue&type=script&lang=js&"
import style0 from "./CoverLoader.vue?vue&type=style&index=0&id=3a8ce498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8ce498",
  null
  
)

export default component.exports